import { SPECS_DESC_1, SPECS_DESC_2 } from '../helpers/content';
import {
	ContentWrapper,
	ContentContainer,
	ContentTitle,
	ContentDesctiptionBonus
} from './ContentStyled';
import volatility from '../assets/volatility.png';
import { VolatilityIcon } from './items/Items';
import { GameConfigs } from '../../lib/globals/GameConfigs';

export default function Specifications({
	dimentions,
	config,
	currency,
	coefs
}) {
	return (
		<ContentWrapper>
			<ContentContainer>
				<div style={{ margin: 'auto' }}>
					<ContentTitle scale={dimentions.scale}>
						GAME SPECIFICATIONS
					</ContentTitle>
				</div>
			</ContentContainer>
			<div style={{ margin: 'auto' }}>
				<VolatilityIcon scale={dimentions.scale}>
					<img src={volatility} alt='volatility' />
				</VolatilityIcon>
				<ContentDesctiptionBonus scale={dimentions.scale}>
					{SPECS_DESC_1()}
					<div>
						<span>
							Maximum Bet: {currency.length > 1 ? currency + ' ' : currency}
							{(+coefs[coefs.length - 1]).toLocaleString(undefined, {
								minimumFractionDigits: GameConfigs.config.currency_prec,
								maximumFractionDigits: GameConfigs.config.currency_prec
							})}
						</span>{' '}
						<span>
							Minimum Bet: {currency.length > 1 ? currency + ' ' : currency}
							{(+coefs[0]).toLocaleString(undefined, {
								minimumFractionDigits: GameConfigs.config.currency_prec,
								maximumFractionDigits: GameConfigs.config.currency_prec
							})}
						</span>
					</div>
					{SPECS_DESC_2(config.rtp)}
				</ContentDesctiptionBonus>
			</div>
		</ContentWrapper>
	);
}
